import React from "react";
import { ArrowLeft } from "lucide-react";

/**
 * Phase 19n — "Back to Stage" pill rendered at the top of any tab that
 * was opened from a stage-gate cross-link. The originating stage code is
 * persisted in sessionStorage as `rachana.tab.{tabKey}.from`.
 *
 * Props:
 *   tabKey       — current tab identifier ("pfd" | "pid" | "simulation" | "model" | …)
 *   onBack       — (stageCode) => void  (typically: () => onOpenTab("stages")
 *                                        + setActiveStageCode(stageCode))
 *   label        — button label (e.g. "Back to Stage B.2")  [optional, auto-derived]
 */
export default function BackToStageBar({ tabKey, onBack, label }) {
  const fromStage = (() => {
    try {
      return sessionStorage.getItem(`rachana.tab.${tabKey}.from`) || "";
    } catch {
      return "";
    }
  })();
  if (!fromStage) return null;
  const text = label || `Back to Stage ${fromStage}`;
  return (
    <div
      style={{
        margin: "0 0 12px",
        padding: "6px 12px",
        border: "1px solid var(--pf-border)",
        borderRadius: 6,
        background: "var(--pf-surface)",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
      }}
      data-testid={`back-to-stage-bar-${tabKey}`}
    >
      <button
        type="button"
        className="btn btn-ghost"
        onClick={() => {
          try {
            sessionStorage.removeItem(`rachana.tab.${tabKey}.from`);
          } catch {}
          onBack(fromStage);
        }}
        data-testid={`back-to-stage-${tabKey}`}
        style={{ fontSize: 12, fontWeight: 600, padding: "4px 10px" }}
      >
        <ArrowLeft size={14} /> {text}
      </button>
      <span style={{ fontSize: 11, color: "var(--pf-text-muted)" }}>
        opened from stage gate
      </span>
    </div>
  );
}
